__turbopack_context__.v({
  "ctaButton": "styles-module__FPed8q__ctaButton",
  "productListItem": "styles-module__FPed8q__productListItem",
});
